import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function StaffSelect({ value, onChange, disabled, testid }) {
  const [staff, setStaff] = useState(null);
  useEffect(() => { api.get("/staff").then(({ data }) => setStaff(data)).catch(() => setStaff([])); }, []);
  useEffect(() => {
    if (staff && value && !staff.some((s) => s.id === value)) {
      onChange("");
    }
  }, [staff, value, onChange]);
  return (
    <select value={value || ""} disabled={disabled} onChange={(e) => onChange(e.target.value)} data-testid={testid}
      className="h-10 w-full rounded-md border border-[var(--border)] px-3 text-sm bg-white disabled:opacity-60">
      <option value="">Nessuno</option>
      {(staff || []).map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
    </select>
  );
}
